<template>
  <!-- 自由入力 -->
  <fieldset
    v-if="props.isFreeForm">
    <div class="ml-8 mt-2 mb-2 w-auto">
      <textarea
        id="freeFormText"
        class="resize w-full rounded border-gray-400"
        cols="30"
        rows="3"
        @input="updateValue" />
    </div>
  </fieldset>

  <!-- チェックボックス -->
  <fieldset
    v-else-if="props.isCheckBox">
    <template
      v-for="(option, index) in options"
      :key="index">
      <label>
        <div class="ml-8 mt-2 mb-2 w-auto">
          <input
            v-model="checkDataList"
            type="checkbox"
            :name="name"
            :value="option.value"
            @change="updateCheckBoxValue" />
          {{ option.label }}
        </div>
      </label>
    </template>
  </fieldset>

  <!-- ラジオボタン -->
  <fieldset
    v-else>
    <template
      v-for="(option, index) in options"
      :key="index">
      <label>
        <div class="ml-8 mt-2 mb-2 w-auto">
          <input
            type="radio"
            :name="name"
            :value="option.value"
            @change="updateValue" />
          {{ option.label }}
        </div>
      </label>
    </template>
  </fieldset>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  options: {
    type: Array,
    default: () => [],
  },
  name: {
    type: String,
    default: '',
  },
  isFreeForm: {
    type: Boolean,
    default: false,
  },
  isCheckBox: {
    type: Boolean,
    default: false,
  },
})

const checkDataList = ref([])

const emit = defineEmits(['update-value', 'update-checkbox-value'])
const updateValue = (e) => {
  emit('update-value', e.target.value)
}

const updateCheckBoxValue = (e) => {
  emit('update-checkbox-value', checkDataList)
}
</script>
